import axios, { AxiosResponse } from "axios";
import {
  mockAxiosResponse,
  mockAxiosResponsesForLocalDevelopment,
} from "./AxiosFakeResponseInterceptors";
import { CREDENTIALS_STORAGE_NAME } from "../Services/SigninService";

const instance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

// Here we can create request and response interceptors
// Request interceptor: The last code triggered for all outgoing requests (used for modifying or logging outgoing requests)
// Response interceptors: The first code handling the response (called even before catch cases in case of errors)
export function useAxiosInterceptors() {
  if (!mockAxiosResponsesForLocalDevelopment) {
    instance.interceptors.request.use((config) => {
      const cred = sessionStorage.getItem(CREDENTIALS_STORAGE_NAME);
      if (cred) {
        config.headers?.set?.("Authorization", `Basic ${cred}`);
      }

      return config;
    });
  } else {
    instance.interceptors.request.use((config) => {
      const urlPath = config.url;
      const method = config.method?.toUpperCase();
      const requestBody = config.data;
      const requestHeaders = config.headers;

      const { status, data } = mockAxiosResponse(
        method ?? "OPTIONS",
        urlPath ?? "/",
        requestBody,
        requestHeaders
      );

      console.log(`Intercepting ${method} https://...${urlPath}`);

      return Promise.reject({
        response: {
          status: status,
          data: data,
        },
      });
    });
  }

  instance.interceptors.response.use(
    (response) => {
      console.log("INTERCEPT response");
      return response;
    },
    (error) => {
      if (
        mockAxiosResponsesForLocalDevelopment &&
        error.response.status >= 200 &&
        error.response.status < 300
      ) {
        console.log(error.response);
        return Promise.resolve(error.response);
      }
      // Non-2xx response case:
      if (error.response) {
        const response = error.response as AxiosResponse;
        if (response.status === 401) {
          //setAuthorizedAs(undefined); // TODO: Not ideal, 401 when accessing ADMIN endpoint with USER role => signout. Fix something better
          console.error(response);
        } else {
          console.error(response);
        }
      } else {
        console.log(error);
      }
      return Promise.reject(error);
    }
  );
}

export default instance;
